import { createFeature, createSelector } from '@ngrx/store';
import { rulesReducer } from '../reducers/rules.reducer';
import { AppState } from '../app.state';
import { iRulesState } from '@app/Shared/interfaces/iRules';

export const rulesFeature = createFeature({
    name: 'rules',
    reducer: rulesReducer,
});

const selectRulesState = (state: AppState) => state.rules;

export const { name: rulesFeatureKey, reducer: rulesFeatureReducer } = rulesFeature;

// Selectors
export const selectRules = createSelector(selectRulesState, (state: iRulesState) => state.rules);

export const selectSelectedRule = createSelector(selectRulesState, (state: iRulesState) => state.selectedRule);

export const selectRulesLoading = createSelector(selectRulesState, (state: iRulesState) => state.isLoading);

export const selectRulesError = createSelector(selectRulesState, (state: iRulesState) => state.error);

// Filtered rules by rule type key
export const selectRulesByRuleTypeKey = createSelector(
    [selectRules],
    (rules) => (DataFieldRuleTypeKey: number | null) => {
        if (DataFieldRuleTypeKey === null) {
            return [];
        }
        return rules.filter((rule) => rule.DataFieldRuleTypeKey === DataFieldRuleTypeKey);
    }
);

export const rulesFeatureSelectors = {
    ...rulesFeature,
    selectRules,
    selectSelectedRule,
    selectRulesLoading,
    selectRulesError,
    selectRulesByRuleTypeKey,
};

export const {
    selectRules: rulesFeatureSelectRules,
    selectSelectedRule: rulesFeatureSelectSelectedRule,
    selectRulesLoading: rulesFeatureSelectRulesLoading,
    selectRulesError: rulesFeatureSelectRulesError,
} = rulesFeatureSelectors;
